export const areObjectEquals = (objectA, objectB) =>
  JSON.stringify(objectA) === JSON.stringify(objectB)
